import { RoundOff_Type } from "../../Services/SettingService";

export const handleRoundoff = (
  totalAmount: number,
  roundoffCheckbox: boolean,
  roundOffType?: RoundOff_Type
) => {
  let amount: number = 0;
  if (roundoffCheckbox && totalAmount > 0) {
    const onlyInteger = Math.floor(totalAmount);
    const onlyPointAmount = totalAmount - onlyInteger;
    if (Number(onlyPointAmount)) {
      if (roundOffType === RoundOff_Type.Normal) {
        if (onlyPointAmount > 0.49) {
          amount = 1 - onlyPointAmount;
        } else {
          amount = -onlyPointAmount;
        }
      } else if (roundOffType === RoundOff_Type.Ceiling) {
        amount = 1 - onlyPointAmount;
      } else if (roundOffType === RoundOff_Type.Floor) {
        amount = -onlyPointAmount;
      }
    }
  } else {
    amount = 0;
  }
  console.log("handleRoundend", amount);
  return amount;
};
